module.exports = __webpack_public_path__ + "img/link-on-premise-bg_1920.9164023.jpg";